(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-living"]) return;
  try {
    
(() => {
  const initialise = () => document.querySelectorAll('[data-dried-florals]').forEach(root => {
    if (root.dataset.floralsReady) return;
    root.dataset.floralsReady = 'true';
    root.querySelectorAll('[data-floral-card]').forEach(card => {
      const form = card.querySelector('.gg-floral-form');
      const select = card.querySelector('[data-floral-variant]');
      const price = card.querySelector('[data-floral-price]');
      const button = card.querySelector('[data-floral-add]');
      const status = card.querySelector('.gg-floral-status');
      if (!form || !button || !status) return;
      const updateVariant = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
        const available = option?.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      };
      select?.addEventListener('change', updateVariant);
      updateVariant();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled) return;
        button.disabled = true;
        button.textContent = button.dataset.addingLabel;
        status.textContent = '';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error('Cart request failed');
          button.textContent = button.dataset.addedLabel;
          status.textContent = button.dataset.addedLabel;
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.site-header .cart-link').forEach(link => {
              link.textContent = `${root.dataset.cartLabel} (${cart.item_count})`;
              link.setAttribute('aria-label', root.dataset.cartAria.replace('__COUNT__', String(cart.item_count)));
            });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(() => {
            if (select) updateVariant();
            else { button.disabled = false; button.textContent = button.dataset.addLabel; }
          }, 1800);
        } catch (error) {
          status.textContent = button.dataset.errorLabel;
          if (select) updateVariant();
          else { button.disabled = false; button.textContent = button.dataset.addLabel; }
        }
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const ggCartForm = document.getElementById('GGCartForm');
  const ggCartCheckout = ggCartForm?.querySelector('[name="checkout"]');
  function updateCheckoutState() {
    if (!ggCartCheckout) return;
    ggCartCheckout.disabled = ggCartCheckout.dataset.bridalInvalid === 'true' || ggCartCheckout.dataset.deliveryInvalid === 'true';
  }
  updateCheckoutState();

  const bridalCheck = document.getElementById('GGBridalCartCheck');
  if (bridalCheck) {
    const form = document.getElementById('GGCartForm');
    const checkout = form.querySelector('[name="checkout"]');
    function validateBridalCart() {
      const rules = document.querySelector('#GGBridalDateRules gg-delivery-calendar');
      const invalid = bridalCheck.dataset.missing === 'true' || !rules?.ready || Array.from(form.querySelectorAll('[data-bridal-delivery-date]')).some((line) => {
        const date = line.dataset.bridalDeliveryDate;
        const parsed = new Date(`${date}T00:00:00Z`);
        return !/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date || !rules.available(parsed);
      });
      const juiceInvalid = Array.from(form.querySelectorAll('[data-bridal-juices]')).some(line => {
        const raw = line.dataset.bridalJuices.split('|');
        const counts = raw.map(Number);
        const boxes = Number(line.querySelector('[name="updates[]"]').value);
        return !Number.isSafeInteger(boxes) || boxes < 6 || raw.some(value => !/^\d+$/.test(value)) || counts.some(value => !Number.isSafeInteger(value) || value < 0)
          || counts.reduce((sum, value) => sum + value, 0) !== boxes;
      });
      checkout.dataset.bridalInvalid = invalid || juiceInvalid ? 'true' : 'false';
      updateCheckoutState();
      bridalCheck.hidden = !invalid && !juiceInvalid;
      return !invalid && !juiceInvalid;
    }
    requestAnimationFrame(validateBridalCart);
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(validateBridalCart), {once: true});
    document.addEventListener('visibilitychange', validateBridalCart);
    form.addEventListener('input', validateBridalCart);
    window.setInterval(validateBridalCart, 60000);
    form.addEventListener('submit', (event) => {
      if (event.submitter?.name === 'checkout' && !validateBridalCart()) event.preventDefault();
    });
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => document.querySelectorAll('[data-sophie-catalogue]').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const choices=[...root.querySelectorAll('[data-category-choice]')];
    const panels=[...root.querySelectorAll('[data-category-panel]')];
    const showCategory = () => {
      if(!choices.length) return;
      const selected=choices.find(a=>a.hash===location.hash)||choices[0];
      choices.forEach(a=>a.setAttribute('aria-current',String(a===selected)));
      panels.forEach(p=>p.hidden=p.dataset.categoryPanel!==selected.dataset.categoryChoice);
    };
    choices.forEach(a=>a.addEventListener('click',e=>{e.preventDefault();history.replaceState(null,'',a.hash);showCategory();}));
    window.addEventListener('hashchange',showCategory);
    showCategory();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regular-orders"] && !Shopify.designMode) return;
  try {
    
(() => {
  const colours = {
    'White chocolate': '#f2e7ce', 'Dark chocolate': '#39251e',
    'Purple': '#8036ba', 'Baby pink': '#f8bed6', 'Hot pink': '#f73499',
    'Red': '#ee2737', 'Orange': '#ff7f32', 'Yellow': '#ffec2d',
    'Royal blue': '#2249af', 'Sky blue': '#59cbe8', 'Lime': '#bcd928',
    'Forest': '#027223', 'Chocolate (brown)': '#623b2a', 'Black': '#000000'
  };
  const initialise = () => {
    document.querySelectorAll('[data-regular-product]').forEach(card => {
      if (card.dataset.regularReady) return;
      card.dataset.regularReady = 'true';
      const variant = card.querySelector('[data-regular-variant]');
      const frequency = card.querySelector('[data-regular-frequency]');
      const price = card.querySelector('[data-regular-price]');
      const button = card.querySelector('[data-regular-add]');
      const optionFields = [...card.querySelectorAll('[data-regular-option]')];
      const variants = variant.options ? [...variant.options].map(option => ({
        id: option.value, options: JSON.parse(option.dataset.options), available: option.dataset.available === 'true'
      })) : [];
      const summary = card.querySelector('[data-regular-frequency-summary]');
      const colourSelect = card.querySelector('[data-regular-colour-select]');
      const preview = card.querySelector('[data-regular-colour-preview]');
      const updatePrice = () => {
        const chosen = frequency.selectedOptions[0];
        price.textContent = chosen?.dataset.price || '';
        const single = frequency.options.length === 1;
        card.querySelector('[data-regular-frequency-field]').hidden = single;
        summary.hidden = !single;
        summary.textContent = chosen?.textContent === 'Deliver every 2 weeks' ? summary.dataset.fortnightLabel : chosen?.textContent || '';
      };
      const updateVariant = () => {
        const previous = frequency.value;
        const plans = [...card.querySelectorAll('template[data-regular-plans]')].find(template => template.dataset.regularPlans === variant.value);
        frequency.replaceChildren();
        if (plans) frequency.append(plans.content.cloneNode(true));
        if ([...frequency.options].some(option => option.value === previous)) frequency.value = previous;
        const selected = variant.selectedOptions?.[0] || variant;
        button.disabled = selected?.dataset.available !== 'true' || !frequency.value;
        button.textContent = !variant.value ? button.dataset.unavailableLabel : button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        updatePrice();
      };
      const updateOptions = () => {
        optionFields.forEach((field, index) => {
          [...field.options].forEach(option => {
            option.disabled = !variants.some(candidate => candidate.options[index] === option.value &&
              optionFields.slice(0, index).every((previous, previousIndex) => candidate.options[previousIndex] === previous.value));
          });
          if (field.selectedOptions[0]?.disabled) field.value = [...field.options].find(option => !option.disabled)?.value || '';
        });
        const chosen = variants.find(candidate => optionFields.every((field, index) => candidate.options[index] === field.value));
        variant.value = chosen?.id || '';
        if (preview && colourSelect) {
          const colour = colours[colourSelect.value];
          preview.hidden = !colour;
          if (colour) {
            card.querySelector('[data-regular-colour-chip]').style.setProperty('--regular-swatch', colour);
            card.querySelector('[data-regular-colour-name]').textContent = colourSelect.value;
          }
        }
        updateVariant();
      };
      variant.addEventListener('change', updateVariant);
      frequency.addEventListener('change', updatePrice);
      if (optionFields.length) {
        const initial = variants.find(candidate => candidate.id === variant.value);
        if (initial) optionFields.forEach((field, index) => { field.value = initial.options[index]; });
        optionFields.forEach(field => field.addEventListener('change', updateOptions));
        updateOptions();
        card.querySelector('[data-regular-fallback]').hidden = true;
        card.querySelector('[data-regular-options]').hidden = false;
      } else updateVariant();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();
})();
